var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{ref:"jsRefCommonTooltip",attrs:{"effect":"light","placement":_vm.placement,"content":_vm.content,"open-delay":500,"popper-class":"jp-common-tooltip"}})
}
var staticRenderFns = []

export { render, staticRenderFns }